
<div class="container">
  <div class="row">
    <div class="col page-title-container">
      <h2 class="hidden-xs-down">Sites</h2>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a [routerLink]="['/projects']">Projects</a></li>
        <li class="breadcrumb-item" *ngIf="projectId &amp;&amp; sites[0]?.projectName"><a [routerLink]="['/project']" [queryParams]="{id: projectId}">{{ sites[0]?.projectName }}</a></li>
        <li class="breadcrumb-item active">Sites</li>
      </ol>
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <list-controls [projectId]="projectId" [isContactRefresh]="contactRefresh" [search]="searchText" [placeholder]="placeholder" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="totalCount" (onChange)="onListControlsChange($event)">
        <div class="btn-group float-right pr-1">
          <div class="dropdown" *ngIf="projectId">
            <button class="btn btn-primary dropdown-toggle" id="importSiteButton" data-toggle="dropdown" type="button">Import Site</button>
            <div class="dropdown-menu dropdown-menu-right"><a class="dropdown-item" id="importSiteITSMLink" href="javascript:void(0)" (click)="addITSMSite()">Import Site from ITSM</a></div>
          </div>
        </div>
        <div class="btn-group float-right pr-1" *appSetting="'enableMultiSiteDesignFeature'">
          <md-spinner *ngIf="isFileDownloading" style="margin-top: 6px; height: 30px;"></md-spinner>
          <div class="dropdown" *ngIf="projectId">
            <button class="btn btn-primary dropdown-toggle" data-toggle="dropdown" type="button" [disabled]="isFileDownloading">Multisite Design</button>
            <div class="dropdown-menu dropdown-menu-right"><span class="dropdown-item" style="display: flex; justify-content: space-between;"><a href="javascript:void(0)" (click)="exportMultiSiteMdf()" (isDownloading)="setFileDownload($event)">Export Multisite Design</a><a *ngIf="isS3LinkAvailable" style="float:right;color:inherit;margin-left: 10px;" href="javascript:void(0)" (click)="downloadMultiSiteMdf()">(Click to download)</a></span><span class="dropdown-item"><a [uploadFileTo]="'/api/sites/import-multi-site-design-file?projectId=' + projectId" [fileExtensions]="['xls', 'xlsx', 'xlsm', 'xlsb']" [title]="'Upload Site List'" (closed)="uploadModalClosed($event)">Import Multisite Design</a></span></div>
          </div>
        </div>
      </list-controls>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="form-group form-check">
        <input class="form-check-input" type="checkbox" name="searchSerialNumber" [(ngModel)]="searchSerialNumber" autoLinkToLabel (change)="changePlaceHolder()">
        <label class="form-check-label">Search Device Serial Number Only</label>
      </div>
    </div>
    <div class="col"> 
      <div class="span"><a *ngIf="isS3LinkAvailable" style="float: right;color: #28a745;font-size: 100%;font-weight: 600;" href="javascript:void(0)" (click)="downloadMultiSiteMdf()">Click here to download Multisite Design file</a><a *ngIf="mesaage &amp;&amp; !isS3LinkAvailable" style="font-size: 100%;font-weight: 600;float: right;color: #0096d6;font-stretch: condensed;white-space: nowrap;">{{mesaage}}&nbsp;</a></div>
    </div>
  </div>
  <div class="row" *ngIf="loading">
    <div class="col">
      <div class="row">
        <div class="col">
          <div class="card-item">
            <md-spinner-block></md-spinner-block>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="!loading">
    <div class="col">
      <div class="row" *ngFor="let site of sites; let i = index">
        <div class="col">
          <div class="card-item">
            <div class="card-progress-bar float-right">
              <div class="progress">
                <div class="progress-bar" role="progressbar" title="{{ site.deployedPercentageBar.title }}" [ngClass]="site.deployedPercentageBar.type" [style.width]="site.deployedPercentageBar.width + '%'">{{site.deployedPercentageBar.value + "%"}}</div>
              </div>
            </div><span class="badge badge-warning" *ngIf="!site.itsmBuildingId">
              <h4>Site is not imported from ITSM. This site is not supported</h4></span>
            <h4>{{ site.name }}<span class="ml-1" *ngIf="site.city">({{site.city}}{{site.region ? ', ' : ''}}{{site.region}})</span></h4>
            <property-container>
              <property-item [showIf]="site.friendlyName">Location Name: {{ site.friendlyName }}</property-item>
            </property-container>
            <property-container>
              <property-item><a id="siteDetailsLink{{i}}" [href]="'/#/site?id=' + site.id">Details</a></property-item>
              <property-item><a id="setUpSiteLink{{i}}" [href]="'/#/workflow/' + site.workflowId">Set Up Site</a></property-item>
            </property-container>
            <property-container>
              <property-item><a id="oredersLink{{i}}" [href]="'/#/orders?siteId=' + site.id">{{ site.orderCount || 0 }} order(s)</a></property-item>
              <property-item><a id="deploymentsLink{{i}}" [href]="'/#/deployments?projectId=' + projectId + '&amp;siteId=' + site.id">{{ site.deploymentCount || 0 }} deployment(s)</a></property-item>
            </property-container>
            <property-container>
              <property-item [showIf]="site.siteCode">Site Code: {{ site.siteCode }}</property-item>
            </property-container>
            <property-container>
              <property-item [showIf]="site.estimatedStartDate">Start Date: {{ site.estimatedStartDate | date: 'yyyy-MM-dd' : 'UTC' }}</property-item>
              <property-item [showIf]="site.estimatedCompleteDate">End Date: {{ site.estimatedCompleteDate | date: 'yyyy-MM-dd' : 'UTC' }}</property-item>
            </property-container>
            <property-container>
              <property-item>{{ site.plannedDevices }} device(s) planned</property-item>
              <property-item>{{ site.deployedDevices }} device(s) deployed</property-item>
            </property-container>
            <property-container>
              <property-item><a [href]="'/#/device-defects?siteId=' + site.id">Defective Asset Replacements</a></property-item>
              <property-item><a [href]="'/#/device-relocations?siteId=' + site.id">Reused & Relocated Assets</a></property-item>
            </property-container>
            <property-container class="red">
              <property-item [showIf]="site.pastSchedule"><span class="oi oi-clock"></span> {{ site.pastScheduleMessage }}</property-item>
            </property-container>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>